import type { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { accordionLegacyDefaultV0Schema } from './default';

export type LegacyAccordion = z.infer<typeof accordionLegacyDefaultV0Schema>;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet). Single
 * placement, like indent/logo/navigation/menu — no envelope union.
 */
export const LegacyAccordionEntitySchema = createLegacyEntitySchema([
    { name: 'web', schema: accordionLegacyDefaultV0Schema },
]);
